module.exports = __webpack_public_path__ + "img/hk-back.62fbb78d.png";